import { cloneElement, ReactElement, useRef } from "react";
import { useButton, mergeProps } from "react-aria";

export interface Props {
  children: ReactElement<any, any>;
}

/**
 * Tooltips only work on React-Aria components, so to prevent having to use React-Aria components
 * elsewhere in the project we can use this wrapper for using tooltips.
 * https://github.com/adobe/react-spectrum/issues/5733#issuecomment-1918691983
 * @param props any ReactElement.
 * @returns a wrapped ReactElement, for use in a react-aria tooltip.
 */
export default function TooltipButtonWrapper(props: Props) {
  const triggerRef = useRef(null);
  const { buttonProps } = useButton({ ...props.children }, triggerRef);

  return cloneElement(
    props.children,
    mergeProps(buttonProps, props.children.props, { ref: triggerRef })
  );
}
